<label
    *ngIf="label !== ''">
    {{label}}
</label>
<div
    #selection
    [attr.tabindex]="disabled ? null : 0"
    [ngClass]="{'open': isOpen, 'focus': hasFocus, 'below': isBelow, 'above': !isBelow, 'disabled': disabled}"
    (click)="onSelectContainerClick($event)"
    (focus)="onSelectContainerFocus()"
    (keydown)="onSelectContainerKeydown($event)">

    <div class="single"
        *ngIf="!multiple">
        <div class="value"
            *ngIf="optionList.hasSelected">
            <ng-container *ngTemplateOutlet="optionTemplate; context:{option: optionList.selection[0].wrappedOption, onDeselectOptionClick: onDeselectOptionClick}"></ng-container>
            <span *ngIf="!optionTemplate">{{optionList.selection[0].label}}</span>
        </div>
        <div class="placeholder"
            *ngIf="!optionList.hasSelected">
            {{placeholderView}}
        </div>
        <div class="clear"
            *ngIf="allowClear && optionList.hasSelected"
            (click)="onClearSelectionClick($event)">
            &#x2715;
        </div>
        <div class="toggle"
            *ngIf="isOpen">
            &#x25B2;
        </div>
        <div class="toggle"
            *ngIf="!isOpen">
            &#x25BC;
        </div>
    </div>

    <div class="multiple"
        *ngIf="multiple">
        <div class="option"
            *ngFor="let option of optionList.selection">
            <span class="deselect-option"
                (click)=onDeselectOptionClick(option)>
                &#x2715;
            </span>
            {{option.label}}
        </div>
        <div class="placeholder"
            *ngIf="!filterEnabled && !optionList.hasSelected">
            {{placeholderView}}
        </div>
        <input
            *ngIf="filterEnabled"
            #filterInput
            autocomplete="off"
            tabindex="-1"
            [placeholder]="placeholderView"
            [ngStyle]="{'width.px': filterInputWidth}"
            (input)="onFilterInput($event.target.value)"
            (keydown)="onMultipleFilterKeydown($event)"
            (focus)="onMultipleFilterFocus()"/>
    </div>

</div>
<pgs-select-search-dropdown
    *ngIf="isOpen"
    #dropdown
    [multiple]="multiple"
    [optionList]="optionList"
    [notFoundMsg]="notFoundMsg"
    [highlightColor]="highlightColor"
    [highlightTextColor]="highlightTextColor"
    [filterEnabled]="filterEnabled"
    [placeholder]="filterPlaceholder"
    [isBelow]="isBelow"
    [width]="width"
    [top]="top"
    [left]="left"
    [optionTemplate]="optionTemplate"
    (optionClicked)="onDropdownOptionClicked($event)"
    (optionsListClick)="onOptionsListClick()"
    (singleFilterClick)="onSingleFilterClick()"
    (singleFilterFocus)="onSingleFilterFocus()"
    (singleFilterInput)="onFilterInput($event)"
    (singleFilterKeydown)="onSingleFilterKeydown($event)">
</pgs-select-search-dropdown>
